import { render } from "./PropertyTable.vue?vue&type=template&id=1589b607"
import script from "./PropertyTable.vue?vue&type=script&lang=js"
export * from "./PropertyTable.vue?vue&type=script&lang=js"

import "./PropertyTable.vue?vue&type=style&index=0&id=1589b607&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__